import React, { useContext } from 'react';
import { RegistrationContext } from '@/modules/RegisterLayout/contexts/RegistrationContextProvider';
import { useRouter } from 'next/router';
import { Typography } from '@pw-tech/omni-ui';
import { InfoIcon } from 'lucide-react';
import FooterPortal from '@/modules/common/Portals/FooterPortal/FooterPortal';
import { getNextStep } from '@/modules/common/utils';
import Image from 'next/image';
const Pass = () => {
  const {
    registrationDetails,
    submitRegisterForm,
    isFormSubmitting
  } = useContext(RegistrationContext);
  const router = useRouter();
  return <article data-sentry-component="Pass" data-sentry-source-file="index.tsx">
      <Typography variant="heading3" weight="semi-bold" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
        Interview Result
      </Typography>
      <div className="relative flex p-5 bg-[#F6FEF9] rounded-lg gap-2 text-center items-center mt-6 shadow-[0px_1px_8px_0px_rgba(0,0,0,0.08)]">
        <Image src="https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/11b0429b-6d1d-4ba4-9832-5afd5e2369f6.svg" alt="college" width={100} height={100} className="absolute bottom-0 w-[80px] h-[70px] sm:!w-[100px] sm:!h-[100px]" data-sentry-element="Image" data-sentry-source-file="index.tsx" />
        <div className="flex flex-col items-center self-center gap-2 mx-auto text-center">
          <Typography variant="regular" data-sentry-element="Typography" data-sentry-source-file="index.tsx">Congratulations! You have successfully</Typography>
          <Typography variant="heading3" weight="semi-bold" className="!text-[#099250]" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
            Passed The Interview
          </Typography>
        </div>
        <Image src="https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/11b0429b-6d1d-4ba4-9832-5afd5e2369f6.svg" alt="college" width={100} height={100} className="absolute bottom-0 right-4 w-[80px] h-[70px] sm:!w-[100px] sm:!h-[100px]" data-sentry-element="Image" data-sentry-source-file="index.tsx" />
      </div>

      <div className="flex items-center gap-1 mt-2">
        <div className="flex items-center justify-center flex-shrink-0 ">
          <InfoIcon size={20} data-sentry-element="InfoIcon" data-sentry-source-file="index.tsx" />
        </div>
        <Typography variant="regular" className="!text-sm !text-[#757575]" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
          You will recieve a confirmation of the result on your registered email ID
        </Typography>
      </div>

      <div className="py-2">
        <FooterPortal label="Continue" type="button" btnWrapperClass="relative sm:left-[30%]" isFormSubmitting={isFormSubmitting} onClick={() => submitRegisterForm({
        step: getNextStep(router.query.step, registrationDetails?.step)
      }, true)} data-sentry-element="FooterPortal" data-sentry-source-file="index.tsx" />
      </div>
    </article>;
};
export default Pass;